import React from 'react'
import styled from '../../config/theme'

export default function PageHeader ({ title, subtitle, side }: PageHeaderProps) {
  return (
    <Container>
      <Info>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Info>
      {side && (
        <Side>
          {side}
        </Side>
      )}
    </Container>
  )
}

export interface PageHeaderProps {
  title: string
  subtitle: string
  side?: React.ReactNode
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px;
`

const Title = styled.div`
  color: #1c2d41;
  font-weight: 500;
  font-size: 1.3125rem;
  margin-bottom: 4px;
`

const Info = styled.div`

`

const Side = styled.div`

`

const Subtitle = styled.div`
  color: #8392a5;
  font-size: 0.875rem;
`
